import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Product from './components/Product'
import Oferta from './components/Oferta'
import Realizacje from './components/Realizacje'
import CTA from './components/CTA'
import Footer from './components/Footer'

export default function App() {
  return (
    <div className="relative min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Product />
        <Oferta />
        <Realizacje />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}
